import { on } from 'delegated-events'
import {
  setCurrentPaymentMethod,
  setTotal,
  setupPayment,
  setupProcessingFees,
  handleInitialLoad,
} from '../common/payments'

const form = document.querySelector('form.sponsorship-form')
const amountField = form ? form.querySelector('select[name="Amount"]') : null
const totalFields = form ? form.querySelectorAll('.sponsorship-total-field') : null
const processingFeeCheckBox = form ? form.querySelector('[name="IncludeProcessingFees"]') : null
const submitButton = form ? form.querySelector('[name=action_submit]') : null

const state = {
  currentPaymentMethod: null,
  stripe: null,
  stripeCard: null,
  stripePlanId: null,
  paypal: null,
  paypalButtons: null,
  paypalPlanId: null,
  currentTotal: 0,
  isRepeating: true,
}

const fn = {
  init: () => {
    state.stripe = window.Stripe(form.dataset.stripePubKey)
    fn.setupAmount()
    fn.updateSubscriptionPlan()
    handleInitialLoad(state, form)
    setCurrentPaymentMethod(state, form)
    setupPayment(state, form)
    setupProcessingFees(state)
    fn.updatePayment()

    on('reset', 'form.sponsorship-form', () => {
      const holder = document.getElementById('sponsorship-form')

      if (holder) {
        holder.querySelectorAll('.form-content').forEach((x) => x.classList.add('hidden'))
      }
    })
  },

  updatePayment: () => {
    on('change', 'input[name="PaymentMethod"]', () => {
      setCurrentPaymentMethod(state, form)
      setupPayment(state, form)
      if (state.currentPaymentMethod !== 'credit-card') {
        submitButton.disabled = true
      } else {
        submitButton.disabled = false
      }
    })
  },

  updateSubscriptionPlan: () => {
    on('change', 'select[name="Amount"]', () => {
      fn.subscriptionIdCheck()
    })
    on('change', 'input[name="IncludeProcessingFees"]', () => {
      fn.subscriptionIdCheck()
    })
    on('change', 'input[name="PaymentMethod"]', () => {
      fn.subscriptionIdCheck()
    })
  },

  subscriptionIdCheck: () => {
    if (processingFeeCheckBox.checked) {
      state.stripePlanId = document.getElementById(`plan-option-${amountField.value}`).dataset.stripePriceFeeId
      state.paypalPlanId = document.getElementById(`plan-option-${amountField.value}`).dataset.paypalPlanFeeId
    } else {
      state.stripePlanId = document.getElementById(`plan-option-${amountField.value}`).dataset.stripePriceId
      state.paypalPlanId = document.getElementById(`plan-option-${amountField.value}`).dataset.paypalPlanId
    }
    setupPayment(state, form)
    if (document.querySelectorAll('input[name="StripePlanID"]').length) {
      const hiddenInput = document.querySelector('input[name="StripePlanID"]')
      hiddenInput.setAttribute('value', state.stripePlanId)
    } else {
      const hiddenInput = document.createElement('input')
      hiddenInput.setAttribute('type', 'hidden')
      hiddenInput.setAttribute('name', 'StripePlanID')
      hiddenInput.setAttribute('value', state.stripePlanId)
      form.appendChild(hiddenInput)
    }
  },

  setupAmount: () => {
    on('change', 'select[name="Amount"]', () => {
      const value = amountField.value
      value == 360
        ? setTotal(state, value, totalFields, '$', '/year')
        : setTotal(state, value, totalFields, '$', '/month')
    })
  },
}

export default {
  can: () => document.querySelectorAll('#sponsorship-form').length,
  run: fn.init,
}
